module.exports = __webpack_public_path__ + "static/img/Updates version 2.2.0.d71d11e.png";